import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';
import { Observable, from, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { domain } from 'process';

@Injectable({
  providedIn: 'root'
})
export class userAccountsDomainsService {


  

  constructor(
    private baseClient: BaseclientService
  ) { }

 

  /**
   * @description Récupère les données du domain du user
   * @return {Observable}
   */
  getUserAccountDomain(domain:any,provenance?:any ): Observable<any> {
      let  params: any = {
      domain: domain,
         
    };
    if(provenance){
      params["provenance"]=provenance;
    }
    return from(this.baseClient.postBase("getUserAccountDomain", params)).pipe(
      map(data => {
        return data.userAccountDomain;
      })
    );
  }

   /**
   * @description Récupère les données du domain du user 
   * @return {Observable}
   */
   getUserAccountDomainByWebshopId(domain:any,webshopId:any): Observable<any> {
    const params: any = {
      domain: domain ,
     webshopId: webshopId     
    };
    return from(this.baseClient.postBase("getUserAccountDomainByWebshopId", params)).pipe(
      map(data => {
        return data.userAccountDomain;
      })
    );
  }

 /**
   * @description Récupère les données du domain du user 
   * @return {Observable}
   */
 getUserAccountDomainByUser(user:any): Observable<any> {
  const params: any = {
    user: user    
  };
  return from(this.baseClient.postBase("getUserAccountDomainByUser", params)).pipe(
    map(data => {
      return data.userAccountDomain;
    })
  );
}


}
